import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchComponent } from './search/search.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchtermComponent } from './searchterm/searchterm.component';
import { WithoutbarPipe } from './pipes/withoutbar.pipe';
import { ImagecheckPipe } from './pipes/imagecheck.pipe';
import { FilterComponent } from './filter/filter.component';
import { SelectbarPipe } from './pipes/selectbar.pipe';
import { ChartsModule } from 'ng2-charts';
import { CharteditionComponent } from './chartedition/chartedition.component';
import { ReplacecharPipe } from './pipes/replacechar.pipe';
// import { ChartethemesComponent } from './chartethemes/chartethemes.component';
import { CharteyearsComponent } from './charteyears/charteyears.component';
// import { ChartelangComponent } from './chartelang/chartelang.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { ChartelangcibleComponent } from './chartelangcible/chartelangcible.component';
import { SplitsubjectPipe } from './pipes/splitsubject.pipe';
import { DotpipehPipe } from './pipes/dotpipeh.pipe';
import { ChartpaysComponent } from './chartpays/chartpays.component';
import { StatisticComponent } from './statistic/statistic.component';
// import { TabediteurComponent } from './tabediteur/tabediteur.component';
// import { TabdescipComponent } from './tabdescip/tabdescip.component';
// import { TabpayseditComponent } from './tabpaysedit/tabpaysedit.component';
import { TabyaereditComponent } from './tabyaeredit/tabyaeredit.component';
// import { TablangsrcComponent } from './tablangsrc/tablangsrc.component';
// import { TablangcblComponent } from './tablangcbl/tablangcbl.component';
import { CanvasPaysComponent } from './canvas-pays/canvas-pays.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { StatPaysComponent } from './stat-pays/stat-pays.component';
import { SplitcharsPipe } from './pipes/splitchars.pipe';
import { SelectbarsearchPipe } from './pipes/selectbarsearch.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {MatIconModule} from '@angular/material/icon';
import { AboutComponent } from './about/about.component';
@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    AdvancedSearchComponent,
    HeaderComponent,
    FooterComponent,
    SearchtermComponent,
    WithoutbarPipe,
    ImagecheckPipe,
    FilterComponent,
    SelectbarPipe,
    CharteditionComponent,
    ReplacecharPipe,
    CharteyearsComponent,
    SplitsubjectPipe,
    DotpipehPipe,
    ChartpaysComponent,
    StatisticComponent,
    TabyaereditComponent,
    CanvasPaysComponent,
    StatPaysComponent,
    SplitcharsPipe,
    SelectbarsearchPipe,
    AboutComponent
    // ChartethemesComponent,
    // ChartelangComponent,
    // ChartelangcibleComponent,
    // TabediteurComponent,
    // TabdescipComponent,
    // TabpayseditComponent,
    // TablangsrcComponent,
    // TablangcblComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ChartsModule,
    MatSelectModule,
    FontAwesomeModule,
    MatIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
      }),
    NoopAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
